<template>
	<el-dialog
		title="选择好友"
		:visible.sync="innerVisible"
		width="420px"
		append-to-body
		custom-class="card-picker-dialog"
		@open="onOpen"
	>
		<div class="picker-preview-tip">选择一位好友，将其名片发送到当前会话</div>
		<el-input
			v-model="keyword"
			size="small"
			placeholder="搜索好友昵称"
			clearable
			prefix-icon="el-icon-search"
		></el-input>
		<div class="picker-list">
			<div v-if="loading && list.length === 0" class="picker-tip">加载中...</div>
			<div v-else-if="list.length === 0" class="picker-tip">暂无匹配的好友</div>
			<div
				v-for="f in list"
				:key="f.userID"
				class="picker-item"
				:class="{ 'is-active': selected && String(selected.userID) === String(f.userID) }"
				@click="selected = f"
			>
				<head-image :size="34" :name="f.nickname" :url="f.avatar"></head-image>
				<div class="picker-info">
					<div class="picker-name">{{ f.nickname || f.userID }}</div>
				</div>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="innerVisible = false">取消</el-button>
			<el-button size="small" type="primary" :disabled="!selected" @click="onConfirm">发送</el-button>
		</div>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import useFriendStore from '../../store/friendStore.js';

// 发送名片-选择好友面板（微信式"选择朋友"）：
// 数据源为当前客服的好友列表（friendStore，初始化已全量加载），本地按昵称/ID 过滤；
// 选中一位好友后 emit select，由 ChatBox 组装 CardElem 走发送链路（像发消息一样发送）
export default {
	name: 'CardPickerDialog',
	components: {
		HeadImage
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			keyword: '',
			selected: null,
			loading: false
		}
	},
	computed: {
		innerVisible: {
			get() {
				return this.visible
			},
			set(v) {
				this.$emit('update:visible', v)
			}
		},
		friends() {
			return useFriendStore().friends || [];
		},
		list() {
			// 过滤双向删除（status=0）的好友：其名片无法送达，与后台推名片口径一致
			const base = this.friends.filter(f => f.status !== 0);
			const kw = this.keyword.trim().toLowerCase();
			if (!kw) return base;
			return base.filter(f =>
				(f.nickname || '').toLowerCase().includes(kw) || String(f.userID || '').includes(kw)
			);
		}
	},
	methods: {
		onOpen() {
			this.keyword = '';
			this.selected = null;
			// 好友列表为空（初始化未加载/加载失败）时补拉全量；失败静默（下次打开重试）
			if (this.friends.length === 0) {
				this.loading = true;
				useFriendStore().loadFriend({ reset: true, pageSize: 0 }).catch(() => {}).finally(() => {
					this.loading = false;
				});
			}
		},
		onConfirm() {
			if (!this.selected) return;
			this.$emit('select', this.selected);
		}
	}
}
</script>

<style lang="scss" scoped>
.picker-preview-tip {
	font-size: 12px;
	color: #909399;
	margin-bottom: 8px;
}
.picker-list {
	height: 320px;
	overflow-y: auto;
	margin-top: 10px;
	border: 1px solid #ebeef5;
	border-radius: 4px;
}
.picker-tip {
	padding: 24px 0;
	text-align: center;
	color: #909399;
	font-size: 13px;
}
.picker-item {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	cursor: pointer;
}
.picker-item:hover {
	background-color: #f5f7fa;
}
.picker-item.is-active {
	background-color: #ecf5ff;
}
.picker-info {
	margin-left: 10px;
	min-width: 0;
}
.picker-name {
	font-size: 14px;
	color: #303133;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
